import React, { useContext } from 'react'
import courseContext from '../../../Helper/Courses'
import { Breadcrumbs } from '../../../AbstractElements'
import { Container } from 'reactstrap'
import { getFullCourseName } from '../../../utils/course'
import Fees from '../../pages-partial/FeeManagement'

const FeeManagement = () => {
  const { activeCourse } = useContext(courseContext)

  return (
    <>
      <Breadcrumbs mainTitle={getFullCourseName(activeCourse)} />
      <Container fluid={true} className="dashboard-default">
        <Fees />
      </Container>
    </>
  )
}

export default FeeManagement